import FormControl from "../control";

class Radio extends FormControl {
    init(element) {
        this.setRootElement(element);

        if (!!this.element) {
            this.type = this.getControlType();
            this.validationType = this.type;

            super.init();
        }
    }

    setRootElement(element) {
        this.element = element || document.querySelector('.js-radio');
    }

    getControlType() {
        return 'radio';
    }

    onInputChange(event) {
        if (this.getControlElement().checked) {
            this.element.classList.add('checked');
        } else {
            this.element.classList.remove('checked');
        }

        this.handleValidate();
    }
}

export default Radio;
